export default __webpack_public_path__ + "static/media/exit.fb5e5666.svg";